import React, { createContext, useContext, useEffect, useState } from 'react';
import { createConnection } from 'services/apis/deal/socket';
import { UserContext } from './UserContext';

export const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const { isUserActive, isLoading, currentUser } = useContext(UserContext);

  useEffect(() => {
    // Só conecta se o usuário está autenticado e a verificação foi completada
    if (!isLoading && isUserActive) {
      try {
        const newSocket = createConnection({ userId: currentUser?.id });

        // Connection events
        newSocket.on('connect', () => {
          setIsConnected(true);
          setConnectionError(null);
        });

        newSocket.on('disconnect', (reason) => {
          setIsConnected(false);
        });

        newSocket.on('connect_error', (error) => {
          setConnectionError(error.message);
        });

        newSocket.on('reconnect_attempt', () => {
        });

        setSocket(newSocket);

        // Cleanup na desmontagem ou quando isUserActive muda
        return () => {
          if (newSocket && newSocket.connected) {
            newSocket.disconnect();
          }
        };
      } catch (error) {
        console.error('Erro ao criar conexão Socket:', error);
        setConnectionError(error.message);
      }
    }
  }, [isUserActive, isLoading, currentUser?.id]);

  const value = {
    socket,
    isConnected,
    connectionError,
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket deve ser usado dentro de SocketProvider');
  }
  return context;
}
